import warning from '../_util/warning';
const Icon = () => {
    warning(false, 'Icon', 'Empty Icon');
    return null;
};
export default Icon;
